import { longMonth, shortMonth } from "../../../app/datetimeUtils";

export const miwChartColors = ["#74d4ff", "#0092b8"]; // [tailwind sky 300, tailwind cyan 600]
export const utahChartColors = ["#A0C98B", "#476c29"];

export const formatNumberOneDecimal = (value: number | undefined | null) =>
	value != null ? value.toFixed(1) : "-";

export const formatNumberOneDecimalZeroToDash = (value: number | undefined | null) =>
	value != null && value !== 0 ? value.toFixed(1) : "-";

export const formatNumber = (value: number | undefined | null) => (value != null ? value : "-");

export const formatNumberWithCommas = (value: number | undefined | null) => {
	if (value == null) return "-";
	return value.toLocaleString("en-US");
};

const TRAIT_TOTAL = 0;
const TRAIT_CONVENTIONS = 6;

export const getMaxValue = (trait: number, actualMax?: number) => {
	if (trait == TRAIT_TOTAL) {
		// Use a max of 36, if the max is larger than 30 to account for teacher scored categories
		return actualMax && actualMax > 30 ? 36 : 30;
	}
	return trait > TRAIT_CONVENTIONS ? 3 : 5;
};

export const getInterval = (trait: number, actualMax?: number) => {
	if (trait == TRAIT_TOTAL) {
		// If getMaxValue is 36, use an interval of 6, otherwise 5
		return actualMax && actualMax > 30 ? 6 : 5;
	}
	return 1;
};

export const tooltipMark = (color: string) =>
	`<span style="background-color:${color}; display: inline-block; margin: 0px 5px 2px 0px; height: 6px; width: 6px; border-radius: 50%;"></span>`;

export const schoolMonths = Array.from({ length: 12 }, (_, i) => ({
	value: shortMonth(1 + ((i + 7) % 12)).toUpperCase(),
	name: longMonth(1 + ((i + 7) % 12)),
}));

// Utilized as a buffer for the area charts
export const extendedSchoolMonths = [
	{ value: "", name: "" },
	...schoolMonths,
	{ value: "", name: "" },
];

export const extendedArray = (dataArray: any) => [0, ...dataArray, 0];
